import axios from "axios";

const address = process.env.NEXT_PUBLIC_API_URL + "/v1/sportcards/";
const headersAuth = (token) => ({ Authorization: `Bearer ${token}` });
const headersAuthFormData = (token) => ({ "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}`, });
const headersAuthJson = (token) => ({ "Content-Type": "application/json", Authorization: `Bearer ${token}`, });


const personCreate = async (data, token) => {
  return axios.post(`${address}persons`, data, { headers: { ...headersAuthJson(token) }, }).then(res => res).catch(err => err);
};

const getPersons = async (token) => {
  return axios.get(`${address}persons`, { headers: { ...headersAuth(token) } }).then(res => res).catch(err => err);
}

const getPerson = async (id, token) => {
  return axios.get(`${address}persons/${id}`, { headers: { ...headersAuth(token) } }).then(res => res).catch(err => err);
}

const updatePersonData = async (id, data, token) => {
  return axios.put(`${address}persons/${id}`, data, { headers: { ...headersAuthJson(token) }, }).then(res => res).catch(err => err);
}

const deletePerson = async (id, token) => {
  return axios.delete(`${address}persons/${id}`, { headers: { ...headersAuth(token) }, }).then(res => res).catch(err => err);
}

const getTempplates = async () => {
  return axios.get(`${address}templates`).then(res => res).catch(err => err);
};

const getPoses = async () => {
  return axios.get(`${address}poses`).then(res => res).catch(err => err);
};

const getBackgrounds = async () => {
  return axios.get(`${address}backgrounds`).then(res => res).catch(err => err);
};

const getLogos = async (token) => {
  return axios.get(`${address}templates/logos`, { headers: { ...headersAuth(token) }, }).then(res => res).catch(err => err);
};

const getFlags = async () => {
  return axios.get(`${address}templates/flags`,).then(res => res).catch(err => err);
};

const createCard = async (data, token) => {
  return axios.post(`${address}cards`, data, { headers: { ...headersAuthJson(token) }, }).then(res => res).catch(err => err);
};

const getCardsList = async (id, token) => {
  return axios.get(`${address}cards?person_id=${id}`, { headers: { ...headersAuth(token) }, }).then(res => res).catch(err => err);
};

export { personCreate, getTempplates, getPoses, getLogos, getBackgrounds, getFlags, getPersons, updatePersonData, getPerson, createCard, deletePerson, getCardsList }